import React from 'react';
import Fade from 'react-reveal/Fade';
import { Col } from 'react-bootstrap';


const TextCol = ({
  title, info, info2, lg, sm,
  isDesktop, isMobile,
}) => (
  <Col lg={lg} sm={sm}>
    <Fade
      right={isDesktop}
      bottom={isMobile}
      duration={1000}
      delay={500}
      distance="30px"
    >
      <div className="project-wrapper__text">
        <h3 className="project-wrapper__text-title gon-font">{title}</h3>
        <div>
          <p>{info}</p>
          <p className="mb-4">{info2}</p>
        </div>
      </div>
    </Fade>
  </Col>
);


export default TextCol;
